import { Navigate } from 'react-router-dom'
import { useAuth } from '../stores/authStore'
import { GlobalLoading } from './GlobalLoading'

interface AuthGuardProps {
  children: React.ReactNode
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { session, loading } = useAuth()

  // Show loading while auth state is being determined
  if (loading) {
    return <GlobalLoading />
  }

  // Only redirect to login if we're sure there's no session (not loading)
  if (!session) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
